module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "expertise"
  }, [_c('h1', [_vm._v("Projects")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('view-portfolio', {
    attrs: {
      "data": _vm.projects,
      "itemsPerPage": _vm.itemsPerPage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37f00600!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/projects.vue
// module id = 50
// module chunks = 1